export function percentile(sortedValues, percentile) {
  if (sortedValues.length === 0) {
    return null;
  }

  const index = (sortedValues.length - 1) * percentile;
  const lowerIndex = Math.floor(index);
  const upperIndex = Math.ceil(index);
  const lowerValue = sortedValues[lowerIndex];
  const upperValue = sortedValues[upperIndex];
  return (upperValue + lowerValue) / 2;
}
